import { RecipeManagementAction } from './actions';
import { RecipeManagementActionTypes } from './constants';

type State = {
    recipe: any | null; // single recipe
    error: string | null;
    loading: boolean;
    message: string | null;
};

const initialState: State = {
    recipe: null,
    error: null,
    loading: false,
    message: null,
};

type RecipeManagementActions =
    | { type: typeof RecipeManagementActionTypes.RECIPE_ADD }
    | { type: typeof RecipeManagementActionTypes.RECIPE_ADD_SUCCESS; payload: { recipe: any } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_ADD_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_LIST }
    | { type: typeof RecipeManagementActionTypes.RECIPE_LIST_SUCCESS; payload: { recipe: any } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_LIST_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_UPDATE }
    | { type: typeof RecipeManagementActionTypes.RECIPE_UPDATE_SUCCESS; payload: { recipe: any } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_UPDATE_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_DELETE }
    | { type: typeof RecipeManagementActionTypes.RECIPE_DELETE_SUCCESS; payload: { recipe_id: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_DELETE_ERROR; payload: { error: string } }
    | { type: typeof RecipeManagementActionTypes.RECIPE_RESET };

const RecipeManagementReducer = (state = initialState, action: RecipeManagementActions): State => {
    switch (action.type) {
        case RecipeManagementActionTypes.RECIPE_ADD:
        case RecipeManagementActionTypes.RECIPE_UPDATE:
        case RecipeManagementActionTypes.RECIPE_DELETE:
        case RecipeManagementActionTypes.RECIPE_LIST:
            return { ...state, loading: true, error: null };

        case RecipeManagementActionTypes.RECIPE_ADD_SUCCESS:
        case RecipeManagementActionTypes.RECIPE_LIST_SUCCESS:
        case RecipeManagementActionTypes.RECIPE_UPDATE_SUCCESS:
            return { ...state, loading: false, recipe: action.payload.recipe };

        case RecipeManagementActionTypes.RECIPE_DELETE_SUCCESS:
            return { ...state, loading: false, recipe: null };

        case RecipeManagementActionTypes.RECIPE_ADD_ERROR:
        case RecipeManagementActionTypes.RECIPE_LIST_ERROR:
        case RecipeManagementActionTypes.RECIPE_UPDATE_ERROR:
        case RecipeManagementActionTypes.RECIPE_DELETE_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        case RecipeManagementActionTypes.RECIPE_RESET:
            return {
                ...state,
                recipe: null,
                loading: false,
                error: null,
                message: null,
            };

        default:
            return state;
    }
};

export default RecipeManagementReducer;
